import React from "react";

import warung1 from "../img/warung1.png";
import warung2 from "../img/warung2.png";
import warung3 from "../img/warung3.png";
import warung4 from "../img/warung4.png";
import warung5 from "../img/warung5.png";
import warung6 from "../img/warung6.png";
import warung7 from "../img/warung7.png";
import warung8 from "../img/warung8.png";
import warung9 from "../img/warung9.png";

import football1 from "../img/football1.png";
import football2 from "../img/football2.png";
import football3 from "../img/football3.png";
import football4 from "../img/football4.png";
import football5 from "../img/football5.png";
import football6 from "../img/football6.png";
import football7 from "../img/football7.png";
import football8 from "../img/football8.png";
import football9 from "../img/football9.png";
import football10 from "../img/football10.png";

import wedding1 from "../img/wedding1.png";
import wedding2 from "../img/wedding2.png";
import wedding3 from "../img/wedding3.png";
import wedding4 from "../img/wedding4.png";
import wedding5 from "../img/wedding5.png";
import wedding6 from "../img/wedding6.png";
import wedding7 from "../img/wedding7.png";

import games1 from "../img/games1.png";
import games2 from "../img/games2.png";
import games3 from "../img/games3.png";
import games4 from "../img/games4.png";
import games5 from "../img/games5.png";
import games6 from "../img/games6.png";
import games7 from "../img/games7.png";
import games8 from "../img/games8.png";

import balinais1 from "../img/balinais1.png";
import balinais2 from "../img/balinais2.png";

import undiknasmobile1 from "../img/undiknasmobile1.jpg";
import undiknasmobile2 from "../img/undiknasmobile2.jpg";

import admission1 from "../img/admission1.png";
import admission2 from "../img/admission2.png";

import rapid1 from "../img/rapid1.png";
import rapid2 from "../img/rapid2.jpg";

import simkeu1 from "../img/simkeu1.png";
import simkeu2 from "../img/simkeu2.png";

import simwisuda from "../img/simwisuda.png";

import playstore from "../img/google-play.png";

class Portfolio extends React.Component {
  constructor() {
    super();
    this.state = {
      portfolio: [
        {
          id: "undiknas-mobile",
          title: "Undiknas Mobile",
          images: [undiknasmobile1, undiknasmobile2],
          details: ['Flutter', 'GraphQL', 'Firebase'],
        },
        {
          id: "football",
          title: "Mobile Apps Football Info",
          images: [football1, football2, football3, football4, football5, football6, football7, football8, football9, football10],
          details: ['Flutter', 'Rest API'],
          playstore: 'https://play.google.com/store/apps/details?id=com.football.info'
        },
        {
          id: "arithmetic",
          title: "Mobile Apps Arithmetic Games",
          images: [games1, games2, games3, games4, games5, games6, games7, games8],
          details: ['Flutter'],
          playstore: 'https://play.google.com/store/apps/details?id=com.arithmetic.games'
        },
        {
          id: "barcode",
          title: "Mobile Apps Barcode Warung",
          images: [warung1, warung2, warung3, warung4, warung5, warung6, warung7, warung8, warung9],
          details: ['Flutter', 'Firebase'],
          playstore: 'https://play.google.com/store/apps/details?id=com.warung.barcode'
        },
        {
          id: "admission",
          title: "Web Apps Admission Undiknas",
          images: [admission1, admission2],
          details: ['Flutter', 'GraphQL', 'Firebase'],
        },
        {
          id: "rapid",
          title: "Web Apps Undiknas Rapid Test",
          images: [rapid1, rapid2],
          details: ['Flutter', 'Firebase'],
        },
        {
          id: "balinais",
          title: "Web Apps Balinais Admin",
          images: [balinais1, balinais2],
          details: ['Angular', 'Node.js', 'Express'],
        },
        {
          id: "simkeu",
          title: "Web Apps SIMKEU",
          images: [simkeu1, simkeu2],
          details: ['PHP', 'Codeigniter', 'Bootstrap', 'JQuery'],
        },
        {
          id: "simwisuda",
          title: "Web Apps SIMWISUDA",
          images: [simwisuda],
          details: ['PHP', 'Codeigniter', 'Bootstrap', 'JQuery'],
        },
        {
          id: "wedding",
          title: "Wedding Invitation Website",
          images: [wedding1, wedding2, wedding3, wedding4, wedding5, wedding6, wedding7],
          details: ['React JS', 'Gatsby', 'Bootstrap', 'JQuery'],
        },
      ],
    };
  }
  render() {
    return (
      <section id="work" className="portfolio-mf sect-pt4 route">
        <div className="container">
          <div className="row">
            <div className="col-sm-12">
              <div className="title-box text-center">
                <h3 className="title-a">Portfolio</h3>
                <p className="subtitle-a">
                  This is some preview of my apps
                </p>
                <div className="line-mf"></div>
              </div>
            </div>
          </div>
          <div className="row">
            {this.state.portfolio.map(portfolio => {
              return (
                <div className="col-md-3">
                  <div className="work-box">
                    <a href={portfolio.images[0]} data-lightbox={portfolio.title}>
                      <div className="work-img">
                        <img src={portfolio.images[0]} alt="" className="img-fluid" />
                      </div>
                      <div className="work-content">
                        <div className="column">
                          <div className="row">
                            <div className="col-sm-8">
                              <h2 className="w-title">{portfolio.title}</h2>
                              <div className="w-more">
                                <span className="w-ctegory">
                                  {portfolio.details.join(', ')}
                                </span>
                              </div>
                            </div>
                            <div className="col-sm-4">
                              <div className="w-like">
                                <span className="ion-ios-eye-outline"></span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </a>
                    {portfolio.playstore ?
                      <a href={portfolio.playstore} target="_blank">
                        <img className="playstore-btn" src={playstore} alt={`playstore-${portfolio.title}`} style={{ margin: 10, maxHeight: 50 }} />
                      </a>
                      : null}
                    {
                      portfolio.images.filter((val, idx, arr) => { return idx > 0 }).map(images => {
                        return (
                          <a
                            href={images}
                            data-lightbox={portfolio.title}
                            style={{ display: "none" }}
                          >
                            jsx-a11y/anchor-has-content warning
                          </a>
                        );
                      })
                    }
                  </div>
                </div>
              );
            })}
          </div>
        </div >
      </section >
    );
  }
}

export default Portfolio;
